export default "assets/images/icons/location-sharp-b5ccb0e1.svg";